import { RqmtTestList } from '@/ac/entities/rqmtTest/RqmtTestList'
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'

export const RqmtDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'rqmtTestTab', label: 'Tests', content: <RqmtTestList rqmtId={entityObj.id} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}